import axios from "axios";
import { getCookie } from "cookies-next";
import { toast } from "react-toastify";

//export const baseDomain ="https://5hkxr440-11000.euw.devtunnels.ms/"
// export const baseDomain ="http://192.168.18.90:8000"
export const baseDomain ="https://limitless.cortechsocial.com/"
// export const baseDomain = "http://127.0.0.1:8000/"
// export const baseDomain ="https://vfv2pt7z-8000.inc1.devtunnels.ms/"

export const axiosInstance = axios.create({
  baseURL: baseDomain,
});

const RequestInterceptor = (config) => {
  const token = getCookie("token");
  console.log("token: ", token);
  if (token) {
    config.headers.Token = ` ${token}`;
  }
  return config;
};

axiosInstance.interceptors.request.use(RequestInterceptor);
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const expectedErrors =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;

    if (!expectedErrors) {
      console.error("Unexpected error", error);
      toast.error("An unexpected error occurred.");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
